module.exports = __webpack_public_path__ + "img/status6.01418504.svg";